import { render } from "./DownloadsView.vue?vue&type=template&id=7581089d&scoped=true"
import script from "./DownloadsView.vue?vue&type=script&lang=js"
export * from "./DownloadsView.vue?vue&type=script&lang=js"

import "./DownloadsView.vue?vue&type=style&index=0&id=7581089d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7581089d"]])

export default __exports__